import axios from 'axios';

export type AdminViewPresetViewType = 'schedule-list';

export type AdminViewPresetPayload = {
    viewType: AdminViewPresetViewType;
    name: string;
    filters: Record<string, unknown>;
};

const headers = (accessToken: string) => ({ authorization: accessToken });

export const getAdminViewPresetsAPI = async (
    centerId: string,
    viewType: AdminViewPresetViewType,
    accessToken: string
): Promise<any> => {
    const response = await axios({
        method: 'get',
        url: `${process.env.REACT_APP_SERVER}/v1/centers/${centerId}/admin-view-presets?viewType=${viewType}`,
        headers: headers(accessToken),
    });
    return response;
};

export const createAdminViewPresetAPI = async (
    centerId: string,
    accessToken: string,
    body: AdminViewPresetPayload
): Promise<any> => {
    const response = await axios({
        method: 'post',
        url: `${process.env.REACT_APP_SERVER}/v1/centers/${centerId}/admin-view-presets`,
        headers: headers(accessToken),
        data: body,
    });
    return response;
};

export const updateAdminViewPresetAPI = async (
    centerId: string,
    presetId: string,
    accessToken: string,
    body: Partial<Pick<AdminViewPresetPayload, 'name' | 'filters'>>
): Promise<any> => {
    const response = await axios({
        method: 'patch',
        url: `${process.env.REACT_APP_SERVER}/v1/centers/${centerId}/admin-view-presets/${presetId}`,
        headers: headers(accessToken),
        data: body,
    });
    return response;
};

export const deleteAdminViewPresetAPI = async (
    centerId: string,
    presetId: string,
    accessToken: string
): Promise<any> => {
    const response = await axios({
        method: 'delete',
        url: `${process.env.REACT_APP_SERVER}/v1/centers/${centerId}/admin-view-presets/${presetId}`,
        headers: headers(accessToken),
    });
    return response;
};
